import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule } from "@angular/common/http";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { FormsModule } from "@angular/forms";
import { SubmitUrlComponent } from "./pages/submit-url/submit-url.component";
import { IframeIntegrationComponent } from "./pages/iframe-integration/iframe-integration.component";
import { SafePipe } from "./pipes/safe.pipe";
import { NotificationComponent } from "./components/notification/notification.component";
import { BankingCaseComponent } from "./pages/banking-case/banking-case.component";
import {
  LucideAngularModule,
  CheckCircle2,
  AlertCircle,
  XCircle,
  Loader2,
} from "lucide-angular";
import { NgxTagCommanderModule, WindowRef } from "ngx-tag-commander";

@NgModule({
  declarations: [
    AppComponent,
    SubmitUrlComponent,
    IframeIntegrationComponent,
    SafePipe,
    NotificationComponent,
    BankingCaseComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    LucideAngularModule.pick({ CheckCircle2, AlertCircle, XCircle, Loader2 }),
    NgxTagCommanderModule,
  ],
  providers: [WindowRef],
  bootstrap: [AppComponent],
})
export class AppModule {}
